import xss from 'xss';
import { convertShortcodeHyphen } from './convertShortcodeHyphen';
import { convertShortcodeDivider } from './convertShortcodeDivider';
import { convertShortcodeBlockQuote } from './convertShortcodeBlockQuote';
import { convertHtmlToReact } from './convertHtmlToReact';

export const processBodyText = (bodyText: string) => {
  const sanitizedBodyText = xss(bodyText, {
    onTagAttr(tag, name, value) {
      if (tag === 'a' && name === 'href') {
        if (value.startsWith('sms:')) {
          return `href="${value}"`;
        }
      }
      return undefined;
    },
  });
  const withHyphens = convertShortcodeHyphen(sanitizedBodyText);
  const withDivider = convertShortcodeDivider(withHyphens);
  const withBlockQuote = convertShortcodeBlockQuote(withDivider);
  const processedBodyText = convertHtmlToReact(withBlockQuote);
  return processedBodyText;
};
